import styled from "styled-components";
import { StyleForm } from "./FormContainer.types";
import { devices } from "../../utils/styled/_variables.styled";

export const FormContainerBox = styled.div<StyleForm>`
  background-color: ${(props: { $backgroundColor: string }) =>
      props.$backgroundColor};
  display: flex;
  gap: 40px;
  padding: 40px 24px;
  flex-direction: column;
  @media ${devices.desktop} {
    padding: 60px 116px;
    flex-direction: row;
  }


 .style-container{
    width: 100%;
 }

 .title__text__container{
    margin-right: 0px;

    @media ${devices.desktop} {
      margin-right: 60px;
    }

    .title__text .title__text__content .title__text__subtitle {
      font-weight: 700;
      font-size: 32px;
      line-height: 110.00000000000001%;
      letter-spacing: 0px;

      @media ${devices.desktop} {
        font-size: 40px;
      }
    }

    .title__text .title__text__content .title__text__text {
      font-weight: 400;
      font-size: 16px;
      line-height: 175%;
      letter-spacing: 0%;

      @media ${devices.desktop} {
        font-size: 18px;
      }
    }
 }

 
`;
